import type { PaymentMethodType } from '../../entities/enums';
import type { HirerPaymentResult } from '../../types';
import type { HandleErrorType } from '../Errors/UseErrorHandler';

import { redirectThirdPartyWithCallback } from './redirectThirdParty';

interface useRedirectThirdParty {
  paymentMethod: PaymentMethodType;
  setIsPaymentInProgress: React.Dispatch<React.SetStateAction<boolean>>;
  handleError: HandleErrorType;
}

// should be a generic pay function that can be used for any customer scenario
const useRedirectThirdParty = ({
  paymentMethod,
  setIsPaymentInProgress,
  handleError,
}: useRedirectThirdParty) => {
  const redirectThirdParty = async (
    execute: () => Promise<HirerPaymentResult>,
  ): Promise<HirerPaymentResult | undefined> => {
    try {
      setIsPaymentInProgress(true);

      return await redirectThirdPartyWithCallback(execute, paymentMethod);
    } catch (error) {
      setIsPaymentInProgress(false);
      handleError(error as unknown as Error);
    }
  };

  return { redirectThirdParty };
};

export default useRedirectThirdParty;
